import React from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import { createTelLink, createMailtoLink } from '@helpers/LinkHelper.js'
import './ContactDetails.module.scss'

const ContactDetails = ({ data }) => {
  const phone = R.propOr('', 'phone', data)
  const email = R.propOr('', 'email', data)
  const instruction = R.propOr('', 'instruction', data)
  const hours = R.propOr('', 'hours', data)
  const callback = R.propOr('', 'callback', data)
  const excluding = R.propOr('', 'excluding', data)
  const telLink = createTelLink(phone)
  const mailtoLink = createMailtoLink(email)

  return (
    <section styleName='contact-details'>
      <div styleName='instruction'>{instruction}</div>
      <div styleName='phone'>
        <a href={telLink}>{phone}</a>
      </div>
      <div styleName='callback'>
        or <a href={mailtoLink} styleName='link'>{callback}</a>
      </div>
      <div styleName='hours'>{hours}</div>
      <div styleName='excluding'>{excluding}</div>
    </section>
  )
}

ContactDetails.propTypes = {
  data: PropTypes.object.isRequired
}

export default ContactDetails



// WEBPACK FOOTER //
// ./src/components/ContactDetails/ContactDetails.js